import { createServer, Model } from "miragejs"

const server = createServer({

  models: {
    empresa: Model,
    usuario: Model,
    catalogo: Model,
    classe: Model,
    color: Model,
    beneficiamento: Model,
    grupo: Model,
    unidade: Model,
    vidro: Model,
    ref: Model,
    produto: Model,
    prodimg: Model,
    libDiversa: Model,
  },

  seeds(server) {

    server.create("empresa", {
      id: 1,
      razao: "Ricardo Ramalho Esquadrias ME",
      fantasia: "RR Esquadrias",
      cnpj: "03.000.265/0001-10",
      perfil: "Sistemista"
    })
    server.create("empresa", {
      id: 2,
      razao: "Marcelo Coelho Ltda",
      fantasia: "MC Esquadrias",
      cnpj: "03.000.265/0001-10",
      perfil: "Fabricante"
    })

    server.create("usuario", {
      id: 1,
      nome: "Antonio Carlos da Silva",
      email: "antonio@teste.com.br"
    })
    server.create("usuario", {
      id: 2,
      nome: "Marcos da Silva",
      email: "marcos@email.com.br",
    })

    server.create("catalogo", {
      id: 1,
      codigo: "SUP-JCR200",
      descricao: "JANELA DE CORRER 2 FOLHAS",
      referencia: { label: "Mercado", value: 2 },
      linha: { label: "Suprema", value: 2 },
      status: { label: "Ativo", value: 1 },
    })
    server.create("catalogo", {
      id: 2,
      codigo: "GOL3-JCR200",
      descricao: "JANELA DE CORRER 2 FOLHAS",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      status: { label: "Ativo", value: 1 },
    })

    server.create("classe", {
      id: 1,
      codigo: "CM",
      descricao: "CONTRAMARCO",
      comum: "SIM"
    })
    server.create("classe", {
      id: 2,
      codigo: "ALU_NAC",
      descricao: "ALUMÍNIO NACIONAL",
      comum: "SIM"
    })

    server.create("color", {
      id: 1,
      color: "Azul",
      material: "Componentes, Kits, Perfis, Superfícies, Vidros",
      comum: "SIM"
    })
    server.create("color", {
      id: 2,
      color: "Branco",
      material: "Componentes, Kits, Perfis",
      comum: "NÃO"
    })

    server.create("beneficiamento", {
      id: 1,
      codigo: "RAL1001",
      codigoInterno: "RAL1001-I",
      descricao: "Pintura Bege"
    })
    server.create("beneficiamento", {
      id: 2,
      codigo: "ALU_IMP",
      codigoInterno: "ALU_IMP-I",
      descricao: "Alumínio Importado"
    })

    server.create("grupo", {
      id: 1,
      codigo: "ACES_IMP",
      descricao: "Acessórios Importados",
      material: "Componentes, Kits, Perfis",
      comum: "Não"
    })
    server.create("grupo", {
      id: 2,
      codigo: "ACES_NAC",
      descricao: "Acessórios Nacionais",
      material: "Componentes, Kits, Perfis, Superfícies, Vidros",
      comum: "Sim"
    })

    server.create("unidade", {
      id: 1,
      sigla: "BR",
      descricao: "Barras"
    })
    server.create("unidade", {
      id: 2,
      sigla: "KG",
      descricao: "Kilos"
    })

    server.create("vidro", {
      id: 1,
      codigo: "VDFL",
      descricao: "Duplo Float + Laminado",
      comum: "Não"
    })
    server.create("vidro", {
      id: 2,
      codigo: "VDFT",
      descricao: "Duplo Float + Temperado",
      comum: "Sim"
    })

    server.create("ref", {
      id: 1,
      ref: "Alumiconte",
      tipo: "Fabricante",
      logo: "Logo 1"
    })
    server.create("ref", {
      id: 2,
      ref: "CDA Metais",
      tipo: "Sistemista",
      logo: "Logo 2"
    })

    server.create("produto", {
      id: 1,
      tipo: "COMPONENTE",
      urlImagem: "https://cdn.leroymerlin.com.br/products/braco_articulacao_para_maxim_ar_aluminio_300mm_2_pecas_90562626_0001_600x600.jpg",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Disponível para Mercado", value: "3" },
      codigo: "BRA-756-BRA-756-BRA7",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM BRAÇO PARA JANELA MAXIM-AR 600MM BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: 1.5,
    })

    server.create("produto", {
      id: 2,
      tipo: "PERFIL",
      urlImagem: "https://bassoaluminios.com.br/system/posts/foto_principals/000/000/036/original/data?1594217698",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em edição", value: 1 },
      codigo: "SU-039",
      codigoInterno: "ESQ-SU-039",
      referencia: { label: "HYDRO", value: 1 },
      linha: { label: "SUPREMA", value: 1 },
      descricao: "MONTANTE LATERAL FOLHA",
      barra1: "6000",
      barra2: "6000",
      barra3: "",
      peso: "1.52",
      ipi: 5,
      classe: { label: "Opção 1", value: 1 },
      unidadeValorizacao: { label: "Opção 1", value: 1 },
      prenativo: { label: "Opção 1", value: 1 },
      perda: { label: "Opção 1", value: 1 },
      perfil: { label: "Sim", value: 1 },
      liga: { label: "Opção 1", value: 1 },
      terminal: { label: "Opção 1", value: 1 },
      tempera: "",
      wx: "",
      jx: "",
      wy: "",
      jy: "",
      perimetroTotal: "",
      perimetroTratamento: "",
    })
    server.create("produto", {
      id: 3,
      tipo: "SUPERFICIE",
      urlImagem: "",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em edição", value: 1 },
      codigo: "SUP-002",
      codigoInterno: "ESQ-SUP-002",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      descricao: "SUPERFICIE ACM",
      cor: { label: "Opção 1", value: 1 },
      unidadeValorizacao: { label: "Opção 1", value: 1 },
      ipi: 5,
      grupo: { label: "Opção 1", value: 1 },
      passo: 5,
      terminal: { label: "Opção 1", value: 1 },
    })
    server.create("produto", {
      id: 4,
      tipo: "VIDRO",
      urlImagem: "https://cdn.leroymerlin.com.br/products/vidro_por_metro_laminado_incolor_8mm_pilar_glass_89820654_0001_1800x1800.jpg",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em edição", value: 1 },
      codigo: "VID-001",
      codigoInterno: "ESQ-VID-001",
      referencia: { label: "Guardian", value: 1 },
      linha: { label: "Ultra Clear", value: 1 },
      descricao: "VIDRO ULTRA CLEAR",
      tipoVidro: { label: "Temperado", value: 1 },
      espessura: 6,
      peso: 1.25,
      fatorLh: 50,
      controleSolar: { label: "Não", value: 2 },
      arredondamento: { label: "Não", value: 2 },
      ipi: 5,
      cor: { label: "Verde", value: 1 },
    })
    server.create("produto", {
      id: 5,
      tipo: "COMPONENTE",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em edição", value: 1 },
      codigo: "BRA-756",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })
    server.create("produto", {
      id: 6,
      tipo: "COMPONENTE",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em edição", value: 1 },
      codigo: "BRA-756",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })
    server.create("produto", {
      id: 7,
      tipo: "COMPONENTE",
      status: { label: "Novo Portfólio", value: "7" },
      situacao: { label: "Indisponível para Mercado", value: "4" },
      codigo: "BRA-756",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })
    server.create("produto", {
      id: 8,
      tipo: "COMPONENTE",
      status: { label: "Arquivo Morto", value: 5 },
      situacao: { label: "Indisponível para Mercado", value: "4" },
      codigo: "SKU-050",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })
    server.create("produto", {
      id: 9,
      tipo: "COMPONENTE",
      status: { label: "Ativo", value: 1 },
      situacao: { label: "Em homologação", value: "2" },
      codigo: "BRA-756",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })

    server.create("produto", {
      id: 10,
      tipo: "COMPONENTE",
      status: { label: "Descontinuado", value: "2" },
      situacao: { label: "Indisponível para Mercado", value: "4" },
      codigo: "BRA-756",
      codigoInterno: "ESQ-BRA-756",
      referencia: { label: "Hydro", value: 1 },
      linha: { label: "Gold", value: 1 },
      grupo: { label: "Braços", value: 1 },
      cor: { label: "Branco", value: 1 },
      descricao: "BRAÇO PARA JANELA MAXIM-AR 600MM",
      unidadeItem: { label: "PC", value: 1 },
      unidadeEmbalagem: { label: "PAR", value: 1 },
      quantidadeEmbalagem: 2,
      otimizacaoBarra: 3000,
      ipi: "",
    })

    server.create("prodimg", {
      id: 1,
      nomeMiniatura: "miniatura.bmp",
      nomeImagem: "imagem.jpg",
      nomeFichaTecnica: "fichatecnica.pdf",
    })
    server.create("prodimg", {
      id: 2,
      nomeMiniatura: "miniatura2.bmp",
      nomeImagem: "imagem2.jpg",
      nomeFichaTecnica: "fichatecnica2.pdf",
    })
    server.create("prodimg", {
      id: 3,
      nomeMiniatura: "miniatura3.bmp",
      nomeImagem: "imagem3.jpg",
      nomeFichaTecnica: "fichatecnica3.pdf",
    })
    server.create("prodimg", {
      id: 4,
      nomeMiniatura: "miniatura4.bmp",
      nomeImagem: "imagem4.jpg",
      nomeFichaTecnica: "fichatecnica4.pdf",
    })

    server.create("libDiversa", {
      id: 1,
      tipo: { label: "Produtos", value: "1" },
      liberacao: { label: "Alumisoft", value: "1" },
      sistema: { label: "CEM", value: "1" },
      referencia: { label: "Hydro", value: "10" },
    })
    server.create("libDiversa", {
      id: 2,
      tipo: { label: "Aplicabilidades", value: "2" },
      liberacao: { label: "Preference", value: "2" },
      sistema: { label: "Pref Closed", value: "4" },
      referencia: { label: "Perfil Alumínio", value: "20" },
    })



  },

  routes() {
    this.namespace = "api-fake";

    this.get("/dashboard/prefsuite", () => [
      {
        TotalObras: "547",
        ue: 250.69,
        TotalPesoObras: 1254,
        TotalObrasPeriodo: [
          {
            data: "01/2019",
            total: 150
          },
          {
            data: "02/2019",
            total: 150
          },
          {
            data: "03/2019",
            total: 600
          },
          {
            data: "04/2019",
            total: 550
          },
          {
            data: "05/2019",
            total: 700
          },
          {
            data: "06/2019",
            total: 450
          },
          {
            data: "07/2019",
            total: 500
          },
          {
            data: "08/2019",
            total: 600
          },
          {
            data: "09/2019",
            total: 200
          },
          {
            data: "10/2019",
            total: 742
          },
          {
            data: "11/2019",
            total: 500
          },
          {
            data: "12/2019",
            total: 600
          },
          {
            data: "1/2020",
            total: 300
          },
          {
            data: "2/2020",
            total: 120
          },
          {
            data: "3/2020",
            total: 120
          },

          {
            data: "4/2020",
            total: 350
          },
          {
            data: "5/2020",
            total: 500
          },
          {
            data: "6/2020",
            total: 600
          },
          {
            data: "7/2020",
            total: 700
          },
          {
            data: "8/2020",
            total: 340
          },
          {
            data: "9/2020",
            total: 800
          },
          {
            data: "10/2020",
            total: 500
          },
          {
            data: "11/2020",
            total: 450
          },
          {
            data: "12/2020",
            total: 600
          }],
        TotalObrasRegiao: [{
          regiao: "Sudeste",
          total: 45
        }, {
          regiao: "Sul",
          total: 2
        }],

        TotalObrasLinha: [{
          linha: "ESPECIFICA 20",
          total: 1
        },
        {
          linha: "GOLD",
          total: 1
        }],
        TotalLinhaPeso: [{
          linha: "ESPECIFICA 20",
          total: 10.04
        },
        {
          linha: "GOLD",
          total: 43.04
        }]
      },
    ])

    this.get("/dashboard/cem", () => [
      {
        TotalObras: "547",
        ue: 250.69,
        TotalPesoObras: 2890,
        TotalObrasPeriodo: [
          {
            data: "01/2019",
            total: 50
          },
          {
            data: "02/2019",
            total: 60
          },
          {
            data: "03/2019",
            total: 70
          },
          {
            data: "04/2019",
            total: 80
          },
          {
            data: "05/2019",
            total: 150
          },
          {
            data: "06/2019",
            total: 250
          },
          {
            data: "07/2019",
            total: 400
          },
          {
            data: "08/2019",
            total: 450
          },
          {
            data: "09/2019",
            total: 369
          },
          {
            data: "10/2019",
            total: 480
          },
          {
            data: "11/2019",
            total: 498
          },
          {
            data: "12/2019",
            total: 657
          },
          {
            data: "1/2020",
            total: 300
          },
          {
            data: "2/2020",
            total: 120
          },
          {
            data: "3/2020",
            total: 120
          },

          {
            data: "4/2020",
            total: 350
          },
          {
            data: "5/2020",
            total: 500
          },
          {
            data: "6/2020",
            total: 460
          },
          {
            data: "7/2020",
            total: 490
          },
          {
            data: "8/2020",
            total: 340
          },
          {
            data: "9/2020",
            total: 200
          },
          {
            data: "10/2020",
            total: 900
          },
          {
            data: "11/2020",
            total: 360
          },
          {
            data: "12/2020",
            total: 1150
          }],
        TotalObrasRegiao: [{
          regiao: "Sudeste",
          total: 500
        },
        {
          regiao: "Sul",
          total: 300
        },
        {
          regiao: "Nordeste",
          total: 950
        }],

        TotalObrasLinha: [{
          linha: "ESPECIFICA 20",
          total: 1
        },
        {
          linha: "GOLD",
          total: 1
        }],
        TotalLinhaPeso: [{
          linha: "ESPECIFICA 20",
          total: 10.04
        },
        {
          linha: "GOLD",
          total: 43.04
        }]
      },
    ])

    this.get("/mof/dashboard/totais", () =>
      [{
        ultimaAtualizacao: "12/12/2020",
        totalAtivo: 150000.00,
      }])

    // Empresas

    this.get("/empresas", (schema) => {
      return schema.empresas.all()
    })

    this.get("/empresas/:string", (schema, request) => {
      let string = request.params.string
      var search = new RegExp(string, 'g');

      return schema.empresas.where(empresa => empresa.razao.match(search));
    })

    this.post("/empresas", (schema, request) => {
      let attrs = JSON.parse(request.requestBody)

      return schema.empresas.create(attrs)
    })


    // Usuários Gerais

    this.get("/usuarios", (schema) => {
      return schema.usuarios.all()
    })

    this.get("/usuarios/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string, 'g');

      let result = usuario => usuario.nome.toLowerCase().match(search);
      if (schema.usuarios.where(result).length == 0) {
        result = usuario => usuario.email.toLowerCase().match(search);
      }

      return schema.usuarios.where(result);
    })


    // Catálogos

    this.get("/catalogos", (schema) => {
      return schema.catalogos.all()
    })

    this.get("/catalogos/id/:id", (schema, request) => {
      let id = request.params.id

      return schema.catalogos.find(id)
    })

    this.get("/catalogos/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string, 'g');

      let result = catalogo => catalogo.tipologia.toLowerCase().match(search);
      let s = schema.catalogos.where(result);

      if (s.length == 0) {
        result = catalogo => catalogo.linha.toLowerCase().match(search);
      }
      if (s.length == 0) {
        result = catalogo => catalogo.referencia.toLowerCase().match(search);
      }

      return schema.catalogos.where(result);
    })


    this.get("/catalogos/perfis", () => {
      let res = {
        dados: [{
          id: 1,
          icone: '',
          codigo: 'VT897',
          descricao: 'FOLHA MONTANTE',
          referencia: 'PERFIL ALUMINIO',
          peso: '1.087'
        },
        {
          id: 2,
          icone: '',
          codigo: 'ECO103',
          descricao: 'BAGUETE QUADRO FIXO',
          referencia: 'PERFIL ALUMINIO',
          peso: '0.150'
        }]
      }
  
      return res;
    })

    this.get("/catalogos/perfis/selecao", () => {
    let res = {
      dados: [{
        id: 1,
        icone: '',
        codigo: 'VT897',
        descricao: 'FOLHA MONTANTE',
        referencia: 'PERFIL ALUMINIO',
        peso: '1.087'
      },
      {
        id: 2,
        icone: '',
        codigo: 'ECO103',
        descricao: 'BAGUETE QUADRO FIXO',
        referencia: 'PERFIL ALUMINIO',
        peso: '0.150'
      }]
    }

    return res;
  })

    // ClasseID

    this.get("/classesid", (schema) => {
      return schema.classes.all()
    })

    this.get("/classesid/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string, 'g');

      let result = classe => classe.codigo.toLowerCase().match(search);
      if (schema.classes.where(result).length == 0) {
        result = classe => classe.descricao.toLowerCase().match(search);
      }

      return schema.classes.where(result);

    })

    // Cores

    this.get("/cores", (schema) => {
      return schema.colors.all()
    })

    this.get("/cores/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string, 'g');

      let result = color => color.color.toLowerCase().match(search);
      if (schema.colors.where(result).length == 0) {
        result = color => color.material.toLowerCase().match(search);
      }
      if (schema.colors.where(result).length == 0) {
        result = color => color.comum.toLowerCase().match(search);
      }

      return schema.colors.where(result);

    })

    // Beneficiamento

    this.get("/beneficiamento", (schema) => {
      return schema.beneficiamentos.all()
    })

    this.get("/beneficiamento/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string, 'g');

      let result = beneficiamento => beneficiamento.codigo.toLowerCase().match(search);
      if (schema.beneficiamentos.where(result).length == 0) {
        result = beneficiamento => beneficiamento.descricao.toLowerCase().match(search);
      }

      return schema.beneficiamentos.where(result);

    })

    // Grupo


    this.get("/grupos", (schema) => {
      return schema.grupos.all()
    })

    this.get("/grupos/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string);

      let result = grupo => grupo.codigo.toLowerCase().match(search);
      if (schema.grupos.where(result).length == 0) {
        result = grupo => grupo.descricao.toLowerCase().match(search);
      }

      return schema.grupos.where(result);

    })

    // UNIDADE


    this.get("/unidades", (schema) => {
      return schema.unidades.all()
    })

    this.get("/unidades/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string);

      let result = unidade => unidade.sigla.toLowerCase().match(search);
      if (schema.unidades.where(result).length == 0) {
        result = unidade => unidade.descricao.toLowerCase().match(search);
      }

      return schema.unidades.where(result);

    })


    // VIDRO


    this.get("/tiposDeVidros", (schema) => {
      return schema.vidros.all()
    })

    this.get("/tiposDeVidros/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string);

      let result = vidro => vidro.codigo.toLowerCase().match(search);
      if (schema.vidros.where(result).length == 0) {
        result = vidro => vidro.descricao.toLowerCase().match(search);
      }

      return schema.vidros.where(result);

    })


    // Referencia


    this.get("/referencias", (schema) => {
      return schema.refs.all()
    })

    this.get("/referencias/:string", (schema, request) => {
      let string = request.params.string.toLowerCase()
      var search = new RegExp(string);

      let result = ref => ref.ref.toLowerCase().match(search);
      if (schema.refs.where(result).length == 0) {
        result = ref => ref.tipo.toLowerCase().match(search);
      }

      return schema.refs.where(result);

    })


    this.get("/referencias/dados", () => [
      {
        id: 1,
        classe: "Classe 1"
      },

      {
        id: 2,
        classe: "Classe 2"
      },
    ])


    // Referencia Linhas

    this.get("/referencias/linhas", () => [
      {
        id: 1,
        linha: "Linha 1",
        logo: "Logo 1"
      },

      {
        id: 2,
        linha: "Linha 2",
        logo: "Logo 2"
      },
    ])


    // Referencia - Linhas  - Prenativo

    this.get("/referencias/linhas/prenativo", () => [
      {
        id: 1,
        codigo: "AUTEM-S",
        descricao: "AUTEM-SOLIDO",
        unidade: "KG",
        tipo: "SÓLIDO"
      },

      {
        id: 2,
        codigo: "AUTEM-T",
        descricao: "AUTEM-TUBULAR",
        unidade: "KG",
        tipo: "TUBULAR"
      },
    ])


    // Referencias - Homologação

    this.get("/referencias/homologacao", () => [
      {
        id: 1,
        tipo: "Referência",
        tipoObj: { label: "Referência", value: 1 },
        // linha: 'Suprema',
        // linhaObj: { label: "Suprema", value: 1 },
        atualizacao: '12/07/21 - 13:25'
      },
      {
        id: 2,
        tipo: "Linha",
        tipoObj: { label: "Linha", value: 2 },
        linha: 'Gold',
        linhaObj: { label: "Gold", value: 2 },
        atualizacao: '13/07/21 - 13:29'
      },
      {
        id: 3,
        tipo: "Tipologias",
        tipoObj: { label: "Tipologias", value: 3 },
        linha: 'Linha 45',
        linhaObj: { label: "Linha 45", value: 3 },
        atualizacao: '14/07/21 - 13:29'
      },

    ])


    // Produtos / Componentes 

    // this.get("/produtos", (schema) => {
    //   return schema.produtos.all()
    // })

    this.get('/produtos', (schema, request) => {

      let qp = request.queryParams
      //let initial = qp.initial
      let limit = parseInt(qp.limit)
      let lastId = parseInt(qp.lastId)
      let busca = qp.busca?.toLowerCase()
      let tipo = qp.tipo?.toLowerCase()
      let situacao = qp.situacao
      let status = qp.status

      let start = lastId
      let end = lastId + limit

      let total = schema.produtos.all()

      // let resultCod = prod => prod.busca.toLowerCase().match(busca)

      // let resultTipo = prod => prod.tipo.toLowerCase().match(tipo)

      function search(obj) {
        let resObj = obj;
        let buscaCodigo = obj.codigo.toLowerCase().match(busca);
        let buscaDescricao = obj.descricao.toLowerCase().match(busca);
        let buscaTipo = obj.tipo.toLowerCase().match(tipo);
        let buscaSituacao = obj.situacao.value.toString().match(situacao);
        let buscaStatus = obj.status.value.toString().match(status);
        // console.log(buscaSituacao)

        resObj = (buscaCodigo || buscaDescricao) && buscaTipo && buscaSituacao && buscaStatus

        return resObj
      }

      let filtered = total.filter(search);

      // let filtered = schema.produtos.where(result)

      // let filtered = schema.produtos.all().slice(start, end)
      let final = filtered.filter((prod, i) => {
        if (prod.id > lastId && i < end)
          return true;
      })


      return {
        filtered: final,
        total: filtered,
        // searchCodigo: search,
        // result: result,        
      }


    })

    this.get("/produtos/:id", (schema, request) => {
      let id = request.params.id

      return schema.produtos.find(id)
    })


    this.get("/prodimgs/:id", (schema, request) => {
      let id = request.params.id

      return schema.prodimgs.find(id)
    })

    this.get("/produtos/outrasCaracteristicas", () => [
      {
        id: 1,
        nome: "Teste",
        descricao: "Teste de descrição",
      },
      {
        id: 2,
        nome: "Teste 2",
        descricao: "Teste de descrição 2",
      },
    ])

    this.get("/produtos/linhasAplicacao", () => [
      {
        id: 1,
        linha: "Linha 1"
      },
      {
        id: 2,
        linha: "Linha 2"
      },

    ])

    this.get("/produtos/aplicabilidade", () => [
      {
        id: 1,
        codigo: "00001",
        descricao: "Aplicabilidade 1",
        referencia: "Referencia 1"
      },
      {
        id: 2,
        codigo: "00002",
        descricao: "Aplicabilidade 2",
        referencia: "Referencia 2"
      },

    ])

    this.get("/produtos/composicao", () => [
      {
        id: 1,
        perfil: "Perfil 1",
        internoExterno: "Interno",
      },
      {
        id: 2,
        perfil: "Perfil 2",
        internoExterno: "Externo",
      },
    ])

    this.get("/produtos/produtoCor", () => [
      {
        id: 1,
        linha: "Linha 1",
      },
      {
        id: 2,
        linha: "Linha 2",
      },
    ])

    this.get("/produtos/vidroCor", () => [
      {
        id: 1,
        cor: { label: "Incolor", value: 1 },
        fatorSolar: 20,
        transLumin: 20,
        transTermica: 20,
        bloqCalor: 20,
        reflexaoInterna: 10,
        reflexaoExterna: 10,
        ativo: true,
      },
      {
        id: 2,
        cor: { label: "Verde", value: 2 },
        fatorSolar: 10,
        transLumin: 10,
        transTermica: 10,
        bloqCalor: 10,
        reflexaoInterna: 10,
        reflexaoExterna: 10,
        ativo: false,
      },


    ])


    // Liberações

    this.get("/liberacoes/alumisoft", () => {

      let res = {
        dados: [{
          id: 1,
          razaoSocial: "JJ Alumínios Ltda - ME",
          nomeFantasia: "JJ Alumínios",
          serial: "CEM30-00000-000A",
          produto: "CEM",
          uf: "SP",
          cidade: "Sorocaba",
          email: "jjaluminios@teste.com.br"
        },
        {
          id: 2,
          razaoSocial: "RR Alumínios Ltda - ME",
          nomeFantasia: "RR Alumínios",
          serial: "CEM30-00222-000A",
          produto: "CEM-SM",
          uf: "SP",
          cidade: "Ribeirão Preto",
          email: "rraluminios@teste.com.br"
        }]
      }

      return res;
    })

    this.get("/projetista", () => [
      {
        id: 1,
        projetista: "Projetista 1"
      },
      {
        id: 2,
        projetista: "Projetista 2"
      },
    ])

    this.get("/pacoteAtualizacao", () => [
      {
        id: 1,
        referencia: "Hydro",
        pacoteAtualizacao: "Pacote 1",
        homologador: "Sim"
      },
      {
        id: 2,
        referencia: "Alumiconte",
        pacoteAtualizacao: "Pacote 2",
        homologador: "Não"
      }
    ])

    this.get('/pacoteReferencia', (schema, request) => {

      let qp = request.queryParams

      let res = {
        dados: [{
          id: 1,
          pacotes: "Pacote 1",
          exclusiva: "Não",
        },
        {
          id: 2,
          pacotes: "Pacote 2",
          exclusiva: "Sim",
        },
        {
          id: 3,
          pacotes: "Pacote 3",
          exclusiva: "Sim",
        },
        {
          id: 4,
          pacotes: "Pacote 4",
          exclusiva: "Não",
        },
        {
          id: 5,
          pacotes: "Pacote 5",
          exclusiva: "Não",
        },
        {
          id: 6,
          pacotes: "Pacote 6",
          exclusiva: "Não",
        },
        {
          id: 7,
          pacotes: "Pacote 7",
          exclusiva: "Não",
        },
        {
          id: 8,
          pacotes: "Pacote 8",
          exclusiva: "Não",
        },
        {
          id: 9,
          pacotes: "Pacote 9",
          exclusiva: "Não",
        },
        {
          id: 10,
          pacotes: "Pacote 10",
          exclusiva: "Não",
        },
        {
          id: 11,
          pacotes: "Pacote 11",
          exclusiva: "Sim",
        }]
      }

      return res;
    })

    this.get('/liberacao/tabelaPrecos', (schema, request) => {

      let qp = request.queryParams

      let res = {
        dados: [{
          id: 1,
          tabelaPreco: "Tabela de Preços - Hydro",
        },
        {
          id: 2,
          tabelaPreco: "Tabela de Preços - Perfil Alumínio",
        }]
      }

      return res
    })

    this.get("/liberacao/tabelaPrecos/selecionados", () => [
      {
        id: 1,
        tabelaPreco: "Tabela de Preços - Hydro",
      },
      {
        id: 2,
        tabelaPreco: "Tabela de Preços - Perfil Alumínio",
      },
    ])

    this.get("/liberacao/aplicabilidade", () => [
      {
        id: 1,
        referencia: "Hydro",
      },
      {
        id: 2,
        referencia: "Perfil Alumínio",
      },
    ])

    this.get("/liberacao/padrao", () => [
      {
        id: 1,
        liberacao: "Liberação 1",
        sistema: "CEM",
        patrocinio: "Perfil",
      },
      {
        id: 2,
        liberacao: "Liberação 2",
        sistema: "CEM Smart",
        patrocinio: "-",
      },
      {
        id: 3,
        liberacao: "Liberação 3",
        sistema: "CEM Mini",
        patrocinio: "-",
      },
    ])

    this.get('/liberacao/preference', () => {

      let res = {
        dados: [{
          id: 1,
          razaoSocial: "AA Alumínios Ltda - ME",
          nomeFantasia: "AA Alumínios",
          serial: "SOKS-DASO-8S9S-AGSF",
          produto: "Pref Open",
          uf: "PE",
          cidade: "Recife",
          email: "aaaluminios@teste.com.br"
        },
        {
          id: 2,
          razaoSocial: "TT Alumínios Ltda - ME",
          nomeFantasia: "TT Alumínios",
          serial: "CMSI-0AS5-AS58-AASO",
          produto: "Pref Closed",
          uf: "SP",
          cidade: "São José do Rio Preto",
          email: "rraluminios@teste.com.br"
        }]
      }

      return res
    })

    this.get("/liberacao/preference/atualizacoes", () => [
      {
        id: 1,
        referencia: "Hydro",
        bloqueio: "Padrão",
      },
      {
        id: 2,
        referencia: "Perfil Alumínio",
        bloqueio: "Parcial",
      },
      {
        id: 3,
        referencia: "Alumiconte",
        bloqueio: "Padrão",
      },

    ])

    this.get("/liberacao/diversas", () => [
      {
        id: 1,
        tipo: "Produtos",
        liberacao: "Alumisoft",
        sistema: "CEM",
        referencia: "Hydro",
        pctLiberado: "-",
        dataLiberacao: "26/08/21 - 13:25"
      },
      {
        id: 2,
        tipo: "Aplicabilidades",
        liberacao: "Preference",
        sistema: "Pref Closed",
        referencia: "Perfil Alumínio",
        pctLiberado: "Pacote 2",
        dataLiberacao: "30/08/21 - 15:31"
      },
    ])

    this.get("/liberacao/diversas/modal/:id", (schema, request) => {

      let id = request.params.id
     
      return schema.libDiversas.find(id)

    })

    // Importar Produtos

    this.get("/importar/produtos", () => [
      {
        id: 1,
        referencia: "Referêmcia 1",
        tipoProduto: "Vidro",
        atualizacao: "24/10/2021",
        situacao: "Situação 1",
      },

      {
        id: 2,
        referencia: "Referência 2",
        tipoProduto: "Componente",
        atualizacao: "24/10/2021",
        situacao: "Situação 2",
      },
    ])

    // Importar Tabela de Preço

    this.get("/importar/tabelaPreco", () => [
      {
        id: 1,
        nome: "Tabela 1",
        referencia: "Referêmcia 1",
        tipoProduto: "Vidro",
        atualizacao: "24/10/2021",
        situacao: "Situação 1",
      },

      {
        id: 2,
        nome: "Tabela 2",
        referencia: "Referência 2",
        tipoProduto: "Componente",
        atualizacao: "24/10/2021",
        situacao: "Situação 2",
      },
    ])

     // Importar Tabela de Preço Modal Nova Tabela

     this.get("/importar/tabelaPreco/novaTabela", () => [
      {
        id: 1,
        nome: "Tabela 1",
        referencia: "Referêmcia 1",
        tipoProduto: "Vidro",
      },

      {
        id: 2,
        nome: "Tabela 2",
        referencia: "Referência 2",
        tipoProduto: "Componente",
      },
    ])

     // Exportar Tabela de Preço

     this.get("/exportar/tabelaPreco", () => [
      {
        id: 1,
        nome: "Tabela 1",
        referencia: "Referêmcia 1",
        criacao: "24/04/2021",
        atualizacao: "24/04/2021",        
      },

      {
        id: 2,
        nome: "Tabela 2",
        referencia: "Referência 2",
        criacao: "24/05/2021",
        atualizacao: "25/05/2021",    
      },
    ])

  },
});

if (process.env.REACT_APP_API != "")
  server.shutdown();